import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@apollo/client";

import { NUTRITIONAL_PLAN } from "graphql/queries";
import { UPDATE_NUTRITIONAL_PLAN } from "graphql/mutations";

import PlanSupplementDrawer from "./PlanSupplementDrawer";
import ClipLoader from "react-spinners/ClipLoader";
export default function PlanSupplementForm({ nutritionalPlanId, supplementOptions, supplementBrands, planMeals }) {

  const { loading, data, error } = useQuery(NUTRITIONAL_PLAN, { variables: { id: nutritionalPlanId } });

  const [updateNutritionaPlan] = useMutation(UPDATE_NUTRITIONAL_PLAN);

  const [hasPlanSupplement, setHasPlanSuppl] = useState("");

  const [open, setOpen] = useState(false);
  {
    /* Check if nutritional plan has already planSupplements */
  }
  useEffect(() => {
    setHasPlanSuppl(data?.nutritionalPlan?.planSupplements.length > 0 ? true : false);
  }, [data]);
  {
    /* Toogle drawer menu */
  }
  const OpenDrawer = () => {
    setOpen(!open);
  };

  if (loading) {
    return <ClipLoader/>;
  }
  if (error) return `Error! ${error}`;

  const { planSupplements } = data.nutritionalPlan;

  return (
    <>
      {hasPlanSupplement ? (
        <section className="rounded-lg bg-white overflow-hidden shadow p-6 flex flex-col">
          <h1 className="text-lg font-bold text-p2-600 self-start mb-2">Supplementi generali <span className="text-xs font-normal">(visibili nel PDF)</span></h1>
          <div className="flex flex-col space-y-8">
            {planSupplements?.map((p) => (
              <div key={p.id} className="mt-2 text-sm font-light text-p2-500">
                <h1 className="text-xs font-bold text-p2-500 pt-2">Nome Pasto</h1>
                {p.mealName}
                <h1 className="text-xs font-bold text-p2-500">Brand</h1>
                {p.brand}
                <h1 className="text-xs font-bold text-p2-500 pt-2">Nome</h1>
                {p.name}
                <h1 className="text-xs font-bold text-p2-500 pt-2">Quantità</h1>
                {p.amount}
              </div>
            ))}
          </div>
          <button className="btn mt-4" onClick={() => setOpen(true)}>
            Modifica
          </button>
        </section>
      ) : (
        <section className="rounded-lg border-dashed border-p2-400 border-2 overflow-hidden p-6">
          <h1 className="text-lg font-bold text-p1-500 pb-2">Supplementi generali</h1>
          <p className="text-p2-500 pb-1">Nessun supplemento generale presente</p>
          <p
            onClick={() => setOpen(true)}
            className="pb-1 underline cursor-pointer text-p1-600"
          >
            Impostali ora
          </p>
        </section>
      )}
      {/* Drawer menu */}
      {open ? (
        <PlanSupplementDrawer 
          direction="col" 
          nutritionalPlanId={nutritionalPlanId} {...{supplementOptions, supplementBrands, planMeals}} 
          open={open} onClick={OpenDrawer} 
        />
      ) : null}
    </>
  );
}
